export class TypeAgent {
    id: number;
    created_by: number;
    name: string;
    real_amount: number;
    percent: number;
    amount: number;
    constructor(name: string = null){
      this.name = name;        
    }
  }